import styled from 'styled-components';

/** Dark module palette aligned with Sacred Monolith–style mockup */
export const plannerColors = {
  bg: '#121212',
  surface: '#1c1c1e',
  surfaceHover: '#252528',
  border: '#2c2c2e',
  text: '#e8e6e3',
  muted: '#8e8e93',
  accent: '#e5d3b3',
  accentSoft: 'rgba(229, 211, 179, 0.18)',
  success: '#34c759',
  warning: '#ffcc00',
  danger: '#ff453a',
} as const;

export const PlannerPage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  min-width: 0;
`;

export const PlannerCard = styled.section`
  background: ${plannerColors.surface};
  border: 1px solid ${plannerColors.border};
  border-radius: 16px;
  padding: 1.1rem 1.25rem;
`;

export const PlannerHeading = styled.h2`
  margin: 10 0;
  font-size: 1.15rem;
  font-weight: 700;
  color: ${plannerColors.text};
  letter-spacing: -0.02em;
`;

export const PlannerKicker = styled.p`
  margin: 0 0 0.35rem;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: ${plannerColors.muted};
`;

export const PlannerSubtle = styled.p`
  margin: 0.35rem 0 0;
  color: ${plannerColors.muted};
  font-size: 0.875rem;
  line-height: 1.45;
`;

export const PlannerInput = styled.input`
  border: 1px solid ${plannerColors.border};
  background: ${plannerColors.surfaceHover};
  color: ${plannerColors.text};
  border-radius: 10px;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;

  &::placeholder {
    color: ${plannerColors.muted};
  }
`;

export const PlannerError = styled.p`
  margin: 0.5rem 0 0;
  color: ${plannerColors.danger};
  font-size: 0.875rem;
`;
